import React from 'react';
import { Edit2, Trash2, Copy, Plus } from 'lucide-react';
import { formatDate } from '../../utils/dateFormat';

const TodoList = ({ todos, onAdd, onEdit, onDelete, onDuplicate }) => {
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '700', color: '#1E293B' }}>
          Client To-Dos ({todos.length})
        </h3>
        <button
          type="button"
          onClick={onAdd}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            padding: '8px 12px',
            background: '#667eea',
            color: '#fff',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '13px',
            fontWeight: '600',
            fontFamily: 'inherit'
          }}
        >
          <Plus size={16} />
          Add To-Do
        </button>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {todos.length === 0 ? (
          <div style={{
            padding: '32px',
            textAlign: 'center',
            color: '#94A3B8',
            fontSize: '14px',
            border: '2px dashed #E2E8F0',
            borderRadius: '12px'
          }}>
            No to-dos created yet. Click "Add To-Do" to get started.
          </div>
        ) : (
          todos.map(todo => (
            <div
              key={todo.id}
              style={{
                padding: '16px',
                border: '1px solid #E2E8F0',
                borderRadius: '12px',
                background: todo.status === 'completed' ? '#F8FAFC' : '#fff'
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: '8px' }}>
                <div style={{ flex: 1 }}>
                  <div style={{
                    fontSize: '15px',
                    fontWeight: '600',
                    color: todo.status === 'completed' ? '#94A3B8' : '#1E293B',
                    textDecoration: todo.status === 'completed' ? 'line-through' : 'none',
                    marginBottom: '4px'
                  }}>
                    {todo.title}
                    {todo.required && <span style={{ color: '#EF4444', marginLeft: '4px' }}>*</span>}
                  </div>
                  <div style={{ fontSize: '13px', color: '#64748B', marginBottom: '8px' }}>
                    Type: <strong>{todo.type}</strong>
                    {todo.due_date && ` • Due: ${formatDate(todo.due_date)}`}
                  </div>
                  {todo.description && (
                    <div style={{ fontSize: '13px', color: '#475569', marginTop: '8px' }}>
                      {todo.description}
                    </div>
                  )}
                  {todo.status === 'completed' && todo.completed_at && (
                    <div style={{ fontSize: '12px', color: '#10B981', marginTop: '8px' }}>
                      ✓ Completed {formatDate(todo.completed_at)}
                    </div>
                  )}
                </div>
                
                <div style={{ display: 'flex', gap: '4px', marginLeft: '12px' }}>
                  <button
                    type="button"
                    onClick={() => onEdit(todo)}
                    title="Edit"
                    style={{
                      padding: '6px',
                      background: '#F1F5F9',
                      border: 'none',
                      borderRadius: '6px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <Edit2 size={14} color="#475569" />
                  </button>
                  <button
                    type="button"
                    onClick={() => onDuplicate(todo)}
                    title="Duplicate"
                    style={{
                      padding: '6px',
                      background: '#F1F5F9',
                      border: 'none',
                      borderRadius: '6px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <Copy size={14} color="#475569" />
                  </button>
                  <button
                    type="button"
                    onClick={() => onDelete(todo.id)}
                    title="Delete"
                    style={{
                      padding: '6px',
                      background: '#FEF2F2',
                      border: 'none',
                      borderRadius: '6px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <Trash2 size={14} color="#EF4444" />
                  </button>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default TodoList;
